import React, { useCallback, useMemo } from 'react';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import { selectLocale } from 'models/localization';
import { useSelector } from 'react-redux';
import getRemappedLinks from 'models/helpers/getRemappedLinks';
import { CustomPageGroup } from 'models/types/customPage';
import DrawerNestedLinks from './DrawerNestedLinks';

const CustomPageNestedLinks = ({ pages, title }: CustomPageGroup) => {
  const locale = useSelector(selectLocale);

  const handleClick = useCallback((key: string) => {
    window.trackingEventToFirebase(null, 'MainMenu_Click', 'CustomPage', key);
  }, []);

  const remappedLinks = useMemo(() => getRemappedLinks(pages, 'mobile', locale, handleClick), [handleClick, locale, pages]);

  return (
    <DrawerNestedLinks
      subLinks={remappedLinks}
      title={findAvailableLocale(title, locale)}
    />
  );
};

export default CustomPageNestedLinks;
